import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { EventService } from '../services/event.service';
import { ApiService } from '../services/api.service';

export const menuGuard: CanMatchFn = async (route: Route, _segments: UrlSegment[]) => {
  const event = inject(EventService), api = inject(ApiService);
  const user = event.user() ? event.user() : await api.userDataFetch()
  const permissions = user?.rolePermission?.permission ?? [];
  const key = (route.data as any)?.root_name ?? route.path?.split('/')?.[0] ?? '';
  return permissions.some((r: any) => r.root_name === key);
};
